import { t } from '@lingui/macro';
import { useLingui } from '@lingui/react';
import { Center, Divider, Grid, Group } from '@mantine/core';
import dayjs from 'dayjs';

import { TTrip } from '../../domains/trips/trip';
import { getNameLocal } from '../../lib/local/get-title';
import { useLocal } from '../../lib/local/use-local';

import styles from './train-route-info.module.css';

const extractTripDates = (date: string, relativeArrivalDelay: number) => {
  const _date = dayjs(date).add(relativeArrivalDelay, 'minute');

  return _date.toDate();
};

const calcTravelTime = (trip: TTrip) => {
  const stationDeparture = dayjs(trip.startTime).add(
    trip.stationFrom.arrivalDelay,
    'minute'
  );
  const stationArrival = dayjs(trip.startTime).add(
    trip.stationTo.arrivalDelay,
    'minute'
  );

  const diff = stationArrival.diff(stationDeparture, 'millisecond');

  const travelTime = dayjs.duration(diff);
  const result = travelTime.format(t`Hч mmм`);

  return result;
};

type TimeBlockProps = {
  date?: Date;
  target?: string;
  direction?: 'start' | 'end';
};

export const TimeBlock = ({
  date,
  target,
  direction = 'start',
}: TimeBlockProps) => {
  useLingui();

  const day = date ? dayjs.tz(date).format('DD MMM') : '';
  const time = date ? dayjs.tz(date).format('HH:mm') : '';
  return (
    <div className={styles.timeBlockContainer} data-direction={direction}>
      {date && <span className={styles.timeBlockDate}>{day}</span>}
      {date && <span className={styles.timeBlockTime}>{time}</span>}
      {target && <span className={styles.timeBlockTarget}>{target}</span>}
    </div>
  );
};

export const TrainRouteInfo = ({
  trip = {
    id: 0,
    route: {
      id: 0,
      number: '',
      nameHy: null,
      nameEn: null,
      nameRu: '',
      stationFromId: 0,
      stationToId: 0,
    },
    trainType: {
      id: 0,
      nameHy: null,
      nameEn: null,
      nameRu: '',
    },
    startTime: '',
    finishTime: '',
    wagons: null,
    stationFrom: {
      routeId: 0,
      station: {
        id: 0,
        nameHy: null,
        nameEn: null,
        nameRu: null,
      },
      arrivalDelay: 0,
      waitDuration: 0,
    },
    stationTo: {
      routeId: 0,
      station: {
        id: 0,
        nameHy: null,
        nameEn: null,
        nameRu: null,
      },
      arrivalDelay: 0,
      waitDuration: 0,
    },
    seatTicketSupported: false,
  },
}: {
  trip?: TTrip;
}) => {
  const [lang] = useLocal();
  const startDate = extractTripDates(
    trip.startTime,
    trip.stationFrom.arrivalDelay
  );
  const finishDate = extractTripDates(
    trip.startTime,
    trip.stationTo.arrivalDelay
  );

  const travelTime = calcTravelTime(trip);

  return (
    <>
      <Group align="center" spacing="xs">
        <span className={styles.trainNumber}>{trip.route.number}</span>

        <span className={styles.trainRoute}>
          {getNameLocal(lang, trip.trainType)} {getNameLocal(lang, trip.route)}
        </span>
      </Group>

      <Grid align="center" justify="center" gutter={10} mt="xs">
        <Grid.Col span="content">
          <TimeBlock
            date={startDate}
            target={getNameLocal(lang, trip?.stationFrom?.station)}
          />
        </Grid.Col>
        <Grid.Col span="auto">
          {/* <Flex align="center" justify="center" direction="column"> */}
          <Center className={styles.pathInfoTitle}>{travelTime}</Center>
          <Divider my={2} />
          {/* <Center className={styles.pathInfoTitle}>остановок: 8шт</Center> */}
          {/* </Flex> */}
        </Grid.Col>
        <Grid.Col span="content">
          <TimeBlock
            date={finishDate}
            target={getNameLocal(lang, trip?.stationTo?.station)}
            direction="end"
          />
        </Grid.Col>
      </Grid>
    </>
  );
};
